import React from "react";
import "./patners.css";

function Patners() {
  return (
    <div className="patners">
      <div className="patnerswrapper">
        <h3>Our Patners</h3>
        <div className="listofpat">
          <div className="patitem">
            <h4>Kakan Enterprises</h4>
            <div>logo</div>
          </div>
          <div className="patitem">
            <h4>Mariko Limited</h4>
            <div>logo</div>
          </div>
          <div className="patitem">
            <h4>Olela Systems</h4>
            <div>logo</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Patners;
